import EmailSupportLink from '../components/email-support-link';
import Header from '../components/header';
import styles from '../css/errorPage.module.scss';
import { ReactComponent as PostBoxImage } from '../media/postbox-round.svg';
import { useScrollToTop } from '../utils/use-scroll-to-top';

export default function ErrorPage(): JSX.Element {
  useScrollToTop();

  return (
    <>
      <Header />
      <section className={styles.page}>
        <header className={styles.header}>
          <h1 className={styles.pageTitle}>
            Oops, something went wrong&hellip;
          </h1>
        </header>
        <div className={styles.container}>
          <PostBoxImage />
          <p className={styles.p}>
            Please return to the email you received about the program and begin
            again.
          </p>
          <hr className={styles.hr} />
          <small className={styles.small}>
            If you keep seeing this screen, please contact Pivot support at:
            <br />
            <EmailSupportLink className={styles.emailLink} />
          </small>
        </div>
      </section>
    </>
  );
}
